import React from "react";
import Navbar from "./Navbar/Navbar";
import Header from "./Header/Header";
import "./banner.css";

const Banner = () => {
  return (
    <div className="banner">
      <Navbar />
      <Header />
    </div>
  );
};

export default Banner;
